import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import { LoginInputDto, LoginResponseDto } from '../models/auth.models';

export type ForgotPasswordInput = { email: string };
export type PasswordHashInput = { hash: string; type?: 'welcome' | 'recovery' };
export type SetPasswordInput = { hash: string; password: string; type?: 'welcome' | 'recovery' };

@Injectable({ providedIn: 'root' })
export class AuthApiService {
  private readonly baseUrl = environment.apiBaseUrl;

  constructor(private readonly http: HttpClient) {}

  login(input: LoginInputDto) {
    return this.http.post<LoginResponseDto>(`${this.baseUrl}/auth/login`, input);
  }

  forgotPassword(input: ForgotPasswordInput) {
    return this.http.post<{ message: string }>(`${this.baseUrl}/auth/forgot-password`, input);
  }

  validatePassword(input: PasswordHashInput) {
    return this.http.post<{ valid: boolean; type?: string }>(
      `${this.baseUrl}/auth/password/validate`,
      input,
    );
  }

  setPassword(input: SetPasswordInput) {
    return this.http.post<{ message: string }>(`${this.baseUrl}/auth/password/set`, input);
  }
}
